import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import InformationSection from '@/scopes/destinations/components/InformationSection'

export default function PracticalInformation() {
  const intl = useIntl()
  const richText = useCMSPageField('DestinationPage.practicalInformation')

  if (!richText)
    return null

  return (
    <InformationSection html={richText} title={intl.formatMessage({ id: 'destination_practical_information_title' })} />
  )
}
